<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <div class="flex mt-2">
                        <ProductFinder
                            business_type="entity"
                            :business_id="$route.params.id"
                            @select="selectDish"
                        />
                    </div>
                    <div class="flex flex-row-reverse">
                        <CButton
                            color="primary"
                            class="mt-2"
                            @click="create"
                        >Создать</CButton
                        >
                    </div>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <table class="table">
                            <thead>
                                <th class="d-md-block d-none"><input v-model="areTableItemsDraggable" type="checkbox" /></th>
                                <th>Приоритет</th>
                                <th>Название</th>
                                <th>Цена</th>
                                <th></th>
                            </thead>
                            <component
                                :is="!isMobile && areTableItemsDraggable ? 'draggable': 'tbody'"
                                v-model="products"
                                tag="tbody">
                                <tr v-for="product in products" :key="product.id">
                                    <td class="d-md-block d-none">
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="cursor-pointer"
                                        />
                                    </td>
                                    <td>
                                        {{ product.priority }}
                                    </td>
                                    <td>
                                        <CLink
                                            :to="`/entities/${$route.params.code}/${$route.params.id}/products/${product.id}`"
                                        >{{ product.title }}</CLink
                                        >
                                    </td>
                                    <td>
                                        <p>{{ product.price }}</p>
                                        <p v-if="typeof product.weight === 'number'" class="text-gray-400 text-xs">
                                            {{ product.weight }} {{ UNITS_ENUM[product.units] }}
                                        </p>
                                    </td>
                                    <td>
                                        <input
                                            v-model="product.enabled"
                                            type="checkbox"
                                            @change="updateProduct(product)"
                                        />
                                    </td>
                                </tr>
                            </component>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import ProductFinder from '@/components/ProductFinder';
    import { UNITS_ENUM } from '@/utils/units';

    export default {
        name: 'EntityProducts',

        components: {
            EntityTabLinks,
            draggable,
            ProductFinder,
        },

        data() {
            return {
                entity: {},
                products: [],
                areTableItemsDraggable: true,
                UNITS_ENUM
            };
        },

        computed: {
            isMobile() {
                return window.innerWidth < 768
            }
        },

        mounted() {
            const id = this.$route.params.id;
            Vue.axios
                .get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get(`/entities/${id}/entity_products`)
                .then(resp => {
                    this.products = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
        },

        methods: {
            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.products.forEach(product => {
                    reorder.push({
                        id: product.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post(`/entities/${this.entity.id}/entity_products/reorder`, { reorder })
                    .then(() => {
                        this.$router.push(`/entities/${this.$route.params.code}/${this.entity.id}`);
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            create() {
                this.$router.push(
                    `/entities/${this.$route.params.code}/${this.entity.id}/products/create`
                );
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },

            selectDish(id) {
                this.$router.push(`/entities/${this.$route.params.code}/${this.entity.id}/products/${id}`);
            },

            updateProduct(product) {
                Vue.axios.post(`/entities/${this.entity.id}/entity_products/update/${product.id}`, product)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
        },
    };
</script>
<style lang="scss" scoped>
.table {
    tr {
        td {
            padding: .2rem .75rem;
            vertical-align: middle;

            &:nth-child(2) {
                max-width: 30vw;
            }
        }
    }
}
.handle {
  cursor: pointer;
}
</style>
